


















import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixin
import OverviewMixin from "@/mixins/admin/overviewMixin";

// Enums/Data
import { IClient } from "@/models/clients";
import { ISegmentTypes } from "@/data/enums/segments";

@Component({
  components: {
    "products-table": () =>
      import("@/components/app/global/contractProducts/productsTable.vue")
  }
})
export default class ClientOTPs extends Mixins(OverviewMixin) {
  // Props
  @Prop({ default: () => () => [] })
  public routes!: () => any;

  @Prop({ required: true })
  public clientId!: IClient["id"];

  // Data
  public segmentType: ISegmentTypes = ISegmentTypes.CONTRACTS_PRODUCTS_SALE;

  public get tableId() {
    return "OTP1";
  }
}
